import { render, staticRenderFns } from "./quote-imagetext.vue?vue&type=template&id=7a119146&"
import script from "./quote-imagetext.js?vue&type=script&lang=js&"
export * from "./quote-imagetext.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports